export const RECRUITMENT_POOL_PATH = '/recruitment-pools';

export const RECRUITMENT_POOL_STATUS = {
  ACTIVE: 'ACTIVE',
  PAUSED: 'PAUSED',
  CLOSED: 'CLOSED',
} as const;

export const RECRUITMENT_POOL_STATUS_LABELS = {
  [RECRUITMENT_POOL_STATUS.ACTIVE]: 'Active',
  [RECRUITMENT_POOL_STATUS.PAUSED]: 'Paused',
  [RECRUITMENT_POOL_STATUS.CLOSED]: 'Closed',
} as const;

export const CANDIDATE_CHECK_OPTIONS = [
  { value: 'SCREENING_CHECKLIST', label: 'Screening checklist' },
  { value: 'SCREENING_TEST_TASK', label: 'Screening test task' },
  { value: 'SCREENING_CALL', label: 'Screening interview' },
  { value: 'GENERAL_INTERVIEW', label: 'General interview' },
  { value: 'ROLE-ROLE_RELATED_INTERVIEW', label: 'Role related interview' },
  { value: 'CLIENT_INTERVIEW', label: 'Client interview' },
  { value: 'EXECUTIVE_INTERVIEW', label: 'Executive interview' },
];

export const RECRUITMENT_POOL_CREATE = 'RECRUITING_RECRUITMENT_POOL_CREATE';
export const RECRUITMENT_POOL_UPDATE = 'RECRUITING_RECRUITMENT_POOL_UPDATE';
export const RECRUITMENT_POOL_SEARCH = 'RECRUITING_RECRUITMENT_POOL_SEARCH';
